import dayjs from 'dayjs';
import { keepOneAndWanOrLine } from '@/utils/utils';

interface TrendDataItem {
  date: number;
  values: (number | null | undefined)[];
}

interface LegendItem {
  name: string;
  color: string;
}

const AREA_COLORS: Record<string, string> = {
  '#52E7FF': 'rgba(82, 231, 255, 0.3)',
  '#2D8DFF': 'rgba(45, 141, 255, 0.3)',
  '#FFCB47': 'rgba(255, 203, 71, 0.3)',
};

const AREA_COLORS_END: Record<string, string> = {
  '#52E7FF': 'rgba(82, 231, 255, 0)',
  '#2D8DFF': 'rgba(45, 141, 255, 0)',
  '#FFCB47': 'rgba(255, 203, 71, 0)',
};

export const getHighEnergyTrendChartOption = (
  data: TrendDataItem[],
  legendData: LegendItem[],
  dateFormat: string = 'MM-DD'
) => {
  return {
    backgroundColor: 'transparent',
    color: legendData.map(item => item.color),
    legend: {
      top: 0,
      right: 0,
      itemWidth: 16,
      itemHeight: 4,
      data: legendData.map(item => ({ name: item.name, icon: 'rect' })),
    },
    tooltip: {
      trigger: 'axis',
      formatter: (items: any) => {
        const { axisValue } = items[0];
        let str = `<div style="padding: 4px;">${axisValue}</div>`;
        items.forEach((item: any) => {
          const shortName =
            (item.seriesName ?? '').length > 12 ? item.seriesName?.slice(0, 12) + '...' : item.seriesName;
          str += `<div style="margin-top:8px;width:220px;"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${
            item.marker
          }</span>${shortName}</div><div>${keepOneAndWanOrLine(item.value)} kWh</div></div></div>`;
        });
        return str;
      },
    },
    xAxis: {
      type: 'category',
      data: data.map(item => dayjs(item.date).format(dateFormat)),
    },
    yAxis: [{ type: 'value', name: 'kWh' }],
    series: legendData.map((legend, i) => ({
      name: legend.name,
      type: 'line',
      smooth: true,
      symbol: 'none',
      data: data.map(item => (item.values[i] === null || item.values[i] === undefined ? null : item.values[i])),
      itemStyle: { color: legend.color },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            { offset: 0, color: AREA_COLORS[legend.color] ?? 'rgba(82, 231, 255, 0.3)' },
            { offset: 1, color: AREA_COLORS_END[legend.color] ?? 'rgba(82, 231, 255, 0)' },
          ],
        },
      },
    })),
  };
};
